const getInitials = (fullName) => {
  if (!fullName) return "";
  const parts = fullName.trim().split(/\s+/); // Elimina espacios en blanco adicionales
  const initials = parts[0]?.charAt(0) + (parts[1]?.charAt(0) || "");
  return initials.toUpperCase();
};

const getColorFromName = (name, colors) => {
  if (!colors.length) return "#FFFFFF";
  if (name === "" || name == null) return colors[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % colors.length;
  return colors[index];
};

const toLocalDate = (date) => {
  if (!date) return "";
  const localDate = new Date(date);
  return (
    localDate.toLocaleDateString("es-ES") +
    " " +
    localDate.toLocaleTimeString("es-ES", {
      hour: "2-digit",
      minute: "2-digit",
    })
  );
};

module.exports = { getColorFromName, getInitials, toLocalDate };
